import { Table } from '@mantine/core';

import { analyticsTypes } from '../../../types';

import { TableCellContent } from './TableCellContent';

type Props = {
  columns: analyticsTypes.RequestsTableColumn[];
  rows: analyticsTypes.RequestsTableRow[];
};

export const TableBody = ({ rows, columns }: Props) => (
  <Table.Tbody>
    {rows.map((row) => (
      <Table.Tr key={`row ${row.page._id}`}>
        {columns.map(({ key: columnKey }) => (
          <Table.Td key={`cell ${columnKey}`}>
            <TableCellContent row={row} column={columnKey} />
          </Table.Td>
        ))}
      </Table.Tr>
    ))}
  </Table.Tbody>
);
